import * as React from "react";
import { Menu } from "antd";
import Link from "./Link";
import SubMenu from "antd/lib/menu/SubMenu";
import { MenuOutlined } from "@ant-design/icons";

const AdminLayoutMenu = ({ router, translate }: { router: any; translate }) => (
  <Menu
    mode="horizontal"
    className={"header-menu-primary"}
    overflowedIndicator={<MenuOutlined />}
  >
    <Menu.Item key="menu:case_law_document">
      <Link router={router} path="/search?collection=STAV&q=">
        {translate("editors.case_law_documents.case_law_document")}
      </Link>
    </Menu.Item>

    <SubMenu
      key="sub3"
      title={
        <span className={"header-menu-item-label"}>
          {translate("menu.codebooks")}
        </span>
      }
    >
      <Menu.Item key="codebooks:attachment_content_type">
        <Link router={router} path="/codebooks/generic/attachment_content_type">
          {translate("codebooks.attachment_content_type")}
        </Link>
      </Menu.Item>
      <Menu.Item key="codebooks:court_case_type">
        <Link router={router} path="/codebooks/generic/court_case_type">
          {translate("codebooks.court_case_type")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:organisation">
        <Link router={router} path="/organisations">
          {translate("editors.organisations.title")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:case_law_document_type">
        <Link router={router} path="/codebooks/case-law-document-types">
          {translate("editors.case_law_document_types.title")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:decision_type">
        <Link router={router} path="/codebooks/generic/decision_type">
          {translate("codebooks.decision_type")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:index_type_category">
        <Link router={router} path="/index-type-categories">
          {translate("editors.index_type_categories.title")}
        </Link>
      </Menu.Item>

      <Menu.Item key="menu:case_decision_types">
        <Link router={router} path="/case-decision-types">
          {translate("editors.case_decisions.types.title")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:legal_view_types">
        <Link router={router} path="/legal-view-types">
          {translate("editors.legal_view_types.title")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:index_types">
        <Link router={router} path="/index-types">
          {translate("editors.index_types.title")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:attachment_types">
        <Link router={router} path="/attachment-type">
          {translate("editors.attachment_types.title")}
        </Link>
      </Menu.Item>
      <Menu.Item key="menu:court_case_connection_type">
        <Link router={router} path="/court-case-connection-type">
          {translate("editors.court_case_connection_type.title")}
        </Link>
      </Menu.Item>
    </SubMenu>
    <SubMenu
      key="sub:reports"
      title={
        <span>
          <span className={"header-menu-item-label"}>
            {translate("menu.reports")}
          </span>
        </span>
      }
    >
      <Menu.Item>
        <Link router={router} path="/index-harmonization-report">
          {translate("reports.harmonised_index_data_report")}
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link router={router} path="/index-non-harmonized-report">
          {translate("reports.non_harmonised_index_data_report")}
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link router={router} path="/indexes-by-category-data-report">
          {translate("reports.indexes_by_category_data_report")}
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link router={router} path="/indexes-by-date-report">
          {translate("reports.indexes_by_date_report")}
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link router={router} path="/case-law-documents-by-date-report">
          {translate("reports.case_law_documents_by_date_report")}
        </Link>
      </Menu.Item>
    </SubMenu>
  </Menu>
);

export default AdminLayoutMenu;
